import { computed } from 'vue';

import { MAX_PASSENGER_COUNT } from '../config';
import type { PassengersState } from '../types';

export const usePassengersValidation = (passengers: PassengersState) => {
  const isMaxAdultCount = computed(
    () => passengers.ADT === MAX_PASSENGER_COUNT.ADULTS,
  );
  const isMaxChildrenCount = computed(
    () => passengers.INF + passengers.CHD === MAX_PASSENGER_COUNT.CHILDREN,
  );
  const isMaxPassengersCount = computed(
    () => isMaxAdultCount.value && isMaxChildrenCount.value,
  );

  return {
    isMaxPassengersCount,
    isMaxAdultCount,
    isMaxChildrenCount,
  };
};
